//@author: mandy
import { S25Util } from "../../../util/s25-util";
import { DurationI } from "../../../pojo/DurationI";
import { Proto } from "../../../pojo/Proto";

export class S25Durationfilter {
    public static duration(duration: DurationI | Proto.ISODurationString) {
        if (!S25Util || !duration) return "";
        if (typeof duration === "string") return S25Util.ISODurationToStr(duration);
        return S25Util.ISODurationToStr(S25Util.daysHoursMinutesToDuration(duration));
    }
}
